import { Dimensions } from "react-native";

var windowWidth = Dimensions.get('window').width;
var windowHeight = Dimensions.get('window').height;


export default {
  pistache: "#E0F252",
  verdeCaribe: "#E1FFD6",
  primary: "#fc5c65",
  secondary: "#4ecdc4",
  black: "#000",
  white: "#fff",
  medium: "#6e6969",
  light: "#f8f4f4",
  dark: "#0c0c0c",
  danger: "#ff5252",
  blueFollow:"#5D74F0",
  green: "green",
  fuente: "#F5D240",
  yellow: "#F5EA3D",
  lemonGreen: "#35AB20",
  transparent: "rgba(0, 0, 0, 0)",
  darkGray: "#444444",
  brain: "red",
  commentsIcon: "grey",
  aguacateGreen: "#6BB251",

 

  chakra0red: "#FA6765", // accion semilla
  chakra1nar: "orange",  // accion info 
  chakra2ama: "#FAEE70", // accion idea
  chakra3ver: "#5BE366", // accion plan
  chakra4azu: "#53DAFF",           //"#53DAFF", // accion accion
  chakra5vlt: "#B455FF", // accion invite
  chakra6rsa: "#FAAECD", // accion play
  chakra7ryo: "#CCF0F9", // accion branch
  chakra8tur: "#36FACC", // accion requirement
  chakra9aur: "#F5D240", // accion donate
  
// Colores de letras 
  fondoGeneral: "#DAFDBA", //"#B3F7A6",
  textGeneral: "#444444",  
  fondoImagenes: "#98D18C", // este fondo sirve para que si las imagenes se tienen que ajustar no se vean mochas.
  fondoInput: "#F3FCD6",

// Colores del onboarding (QuienesSomosScreen)
  slideVioleta: "#6C5CE7",
  slideVerde: "#00B894",
  slideNaranja: "#E17055",
  casiNegro: "#222",
  whiteAlpha40: "rgba(255, 255, 255, 0.4)",
  whiteAlpha90: "rgba(255, 255, 255, 0.9)",


// Estansarización de tamaños de letras 
  // textSmall: (windowWidth *.037),
  // textMedium: (windowWidth *.040),
  // textLarge: (windowWidth *.047),
  // txtS: 0.037,
  // txtM: 0.040,
  // txtL: 0.047,

  fontWeightMedium: '500',
  fontWeightLarge: '600',

// Estandarización de tamaños de width y height para Image e ImageCache
  // imageWidthCardOrigin: (windowWidth*.65),     // En CardOriginComponent
  // imageHeightCardOrigin: (windowHeight*.35), 

  // sizeBrainComments: (windowWidth * .06), // Tamaño icono cerebro y comments
  // sizeTree: (windowWidth * .055),
  // numberSizeTree: 0.055,
  // miniSizeTree: (windowWidth * .048),

  // imageInMosaic: (windowWidth * .32), //Tamaño de los cuadros en el mosaico
};
